<div class="loading-mask" [style.background]="background" [style.opacity]="opacity">
  <mat-spinner [diameter]="diameter" [strokeWidth]="strokeWidth" [color]="'accent'"></mat-spinner>
</div>
